import { type FunctionComponent } from 'react';

import { type FactorType } from '../models';

import { Email, Sms, Totp } from './assets';
import type { invertedMessages } from './messages';

export interface LoginMethod {
  icon: FunctionComponent;
  title: keyof typeof invertedMessages;
  description: keyof typeof invertedMessages;
}

const loginMethods: Record<Exclude<FactorType, 'test'>, LoginMethod> & {
  test: { icon: FunctionComponent; title: string; description: string };
} = {
  sms: {
    icon: Sms,
    title: 'SMS Passcodes',
    description: 'One-time passcodes will be sent to your mobile device.',
  },
  email: {
    icon: Email,
    title: 'Email Passcodes',
    description: 'One-time passcodes will be sent to your email address.',
  },
  totp: {
    icon: Totp,
    title: 'Timed Passcodes',
    description:
      'Enter time-based one-time passcodes (TOTP) via an authenticator.',
  },
  idaas: {
    icon: () => null,
    title: 'Third-party SSO',
    description: 'Use your SSO account to verify your identity.',
  },
  test: {
    icon: () => null,
    title: 'Test Factor',
    description: 'For testing purposes only.',
  },
} as const;

export default loginMethods;
